const initialState = {
    userLists: [],
    userStatus: [],
    InactiveuserLists:[],
    userPermissions: {},
    changedUserStatus : [],
    changedUserPhoto : [],
    changedUserRegistration : [],
    loadingUser: false,
    errorsUser: {}
}

const  userReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_USERLIST_PENDING":
        case "ADD_USER_PENDING":
        case "UPDATE_USER_PENDING":
        case "GET_INACTIVEUSERLIST_PENDING":
        case "DELETE_USER_PENDING":
        case "LOGOUT_USER_DEVICE_PENDING":
        case "GET_USERLISTBYID_PENDING":
        case "RESET_USER_REGISTRATION_PENDING":
        case "ADD_USER_PHOTO_PENDING":
        case "UPDATE_USER_REGISTRATION_STATUS_PENDING":
            return { ...state, loadingUser: true };

        case "GET_USERLIST_FULFILLED":
        case "GET_INACTIVEUSERLIST_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                userLists: action.payload,
                InactiveuserLists:action.payload,
                userCount: action.userCount,
                userPermissions:action.permissions,
            };

        case "ADD_USER_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
            };

        case "ADD_USER_PHOTO_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserPhoto: action.payload,
            };

        case "LOGOUT_USER_DEVICE_FULFILLED":
        case "RESET_USER_REGISTRATION_FULFILLED":
        case "UPDATE_USER_REGISTRATION_STATUS_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
                changedUserRegistration: action.payload,
                };

        case "UPDATE_USER_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload,
            };

        case "GET_USERLISTBYID_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                userLists: action.payload
            };

        case "DELETE_USER_FULFILLED":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: action.payload
            };

        case "RESET_DELETE_USER_STATUS":
            return {
                ...state,
                loadingUser: false,
                changedUserStatus: [],
                errorsUser:{}
            };

        case "GET_USERLIST_REJECTED":
        case "ADD_USER_REJECTED":
        case "GET_INACTIVEUSERLIST_REJECTED":
        case "UPDATE_USER_REJECTED":
        case "DELETE_USER_REJECTED":
        case "LOGOUT_USER_DEVICE_REJECTED":
        case "GET_USERLISTBYID_REJECTED":
        case "RESET_USER_REGISTRATION_REJECTED":
        case "RESET_USER_PHOTO_REJECTED":
        case "ADD_USER_PHOTO_REJECTED":
        case "UPDATE_USER_REGISTRATION_STATUS_REJECTED":
                return {
                ...state,
                loadingUser: false,
                errorsUser: action.payload
            };

        default:
            return state;
    }
}

export default userReducer;
